const api5 = 'https://api5.wargos.cloud'

export const Apis = Object.freeze({
  OAUTH: `https://accounts.wargos.cloud`,
  BASE: `${api5}/xblacklist`,
  USER: `${api5}/xuser`,
  BLACK:`${api5}/xblacklist`,
});
